import React, { Fragment, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  Chip,
  makeStyles,
  colors
} from '@material-ui/core';

import NavItem from './NavItem';

import { FaWaveSquare } from "react-icons/fa";
import { MdRouter } from "react-icons/md";
import { BsSpeedometer2 } from "react-icons/bs";
import { FaHandshake } from "react-icons/fa";
import { MdManageAccounts } from "react-icons/md";
import { RiEqualizerLine } from "react-icons/ri";
import { MdMemory } from "react-icons/md";
import { RiFileCloudLine } from "react-icons/ri";

const items = [
  {
    href: '/cfg/operations',
    icon: FaHandshake,
    title: 'Contrato',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/devices',
    icon: MdRouter,
    title: 'Dispositivo',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/hardwares',
    icon: MdMemory,
    title: 'Hardware',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/messages',
    icon: FaWaveSquare,
    title: 'Protocolo',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/panels',
    icon: BsSpeedometer2,
    title: 'Instrumentação',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/settings',
    icon: RiEqualizerLine,
    title: 'Parâmetros',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/storage',
    icon: RiFileCloudLine,
    title: 'Armazenamento',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ENG'
  },
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {

  const classes = useStyles();

  const [user, setUser] = useState({
    avatar: localStorage.getItem('avatar'),
    firstname: localStorage.getItem('firstname'),
    lastname: localStorage.getItem('lastname'),
    company: localStorage.getItem('company'),
    profile: localStorage.getItem('profile')
  });

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
      setUser(localStorage.getItem('user'));
    }
  }, []);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >

      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={1}
      >
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          variant="circle"
          src={`/static/images/avatars/`}
          to="/cfg/main"
        />
        <Typography
          className={classes.name}
          color="secondary"
          variant="body2"
        >
          {user.firstname} {user.lastname}
        </Typography>
        <Chip
          size="small"
          color="primary"
          label={`Perfil de acesso é ` + user.profile + `.`}
        />
      </Box>
      <Divider />
      <Box p={1}>
        <List>
          {items.map((item) => (
            (item.profile == localStorage.getItem('profile')) ? (
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                color={item.color}
              />) : ('')
          ))}
        </List>
      </Box>
      <Box flexGrow={1} hidden />
      <Box hidden
        p={1}
        m={1}
        bgcolor="background.dark"
      >
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          Quer sair da área de engenharia?
        </Typography>

        <Typography
          align="center"
          variant="body2"
        >
          Aqui você volta para área de administração do sistema
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          mt={1}
        >
          <Button
            color="secondary"
            component="a"
            variant="contained"
            href="/adm/main">
            Administração
          </Button>
        </Box>
      </Box>

    </Box>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {(localStorage.getItem('profile') === 'ENG') ? (
            content
          ) : (
            <div></div>
          )}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {(localStorage.getItem('profile') === 'ENG') ? (
            content
          ) : (
            <div></div>
          )}
        </Drawer>
      </Hidden>
    </Fragment>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default NavBar;
